import { Controller } from "@hotwired/stimulus"

// Manages the dependent contact select on purchase/sale forms.
// Listens for company selection changes, shows/hides the contact
// dropdown, and updates its URL and the slideout's src accordingly.
export default class extends Controller {
  static targets = ["contactSelect", "companySelect"]
  static values = {
    contactsUrl: String
  }

  connect() {
    this.boundCompanyChanged = this.companyChanged.bind(this)
    this.companySelectTarget.addEventListener("searchable-select:change", this.boundCompanyChanged)

    // If company is already selected on edit, ensure contact URL is set
    const existingInput = this.companySelectTarget.querySelector("input[type='hidden']")
    if (existingInput && existingInput.value) {
      this.updateContactUrl(existingInput.value)
      this.updateSlideoutSrc(existingInput.value)
    }
  }

  disconnect() {
    this.companySelectTarget.removeEventListener("searchable-select:change", this.boundCompanyChanged)
  }

  companyChanged(event) {
    const accountId = event.detail.value

    if (accountId) {
      this.contactSelectTarget.classList.remove("hidden")
      this.updateContactUrl(accountId)
      this.updateSlideoutSrc(accountId)
      this.clearContacts()
    } else {
      this.contactSelectTarget.classList.add("hidden")
      this.clearContacts()
    }
  }

  updateContactUrl(accountId) {
    const contactController = this.getContactSearchableSelect()
    if (contactController) {
      const url = new URL(this.contactsUrlValue, window.location.origin)
      url.searchParams.set("account_id", accountId)
      contactController.urlValue = url.pathname + url.search
    }
  }

  updateSlideoutSrc(accountId) {
    const slideout = document.getElementById("add_contact_slideout")
    if (!slideout) return

    const frame = slideout.querySelector("turbo-frame")
    if (!frame) return

    const originalSrc = frame.dataset.originalSrc || frame.getAttribute("src") || ""
    const url = new URL(originalSrc || "/contacts/new", window.location.origin)
    url.searchParams.set("account_id", accountId)
    const newSrc = url.pathname + url.search

    frame.dataset.originalSrc = newSrc
    frame.setAttribute("src", newSrc)
  }

  clearContacts() {
    const contactController = this.getContactSearchableSelect()
    if (!contactController) return

    if (contactController.multipleValue) {
      contactController.selectedItems = []
      contactController.syncHiddenInputs()
      contactController.renderTags()
    } else {
      contactController.setValue("", "Select a contact...")
    }
  }

  getContactSearchableSelect() {
    const container = this.contactSelectTarget.querySelector("[data-controller='searchable-select']")
    if (container) {
      return this.application.getControllerForElementAndIdentifier(container, "searchable-select")
    }
    return null
  }
}
